export default __webpack_public_path__ + "static/lookingup-circle-ba7d745c1906d1f2c0a9ff941f83d27f.png";